import { eachWeekOfInterval, startOfMonth, endOfMonth, format } from 'date-fns';
import React, { forwardRef } from 'react';
import { DaysOfWeekHeader } from './DaysOfWeekHeader.esm.js';
import { Week } from './Week.esm.js';

var DateGrid = forwardRef(function (_a, ref) {
    var activeDate = _a.activeDate, hoverDate = _a.hoverDate, max = _a.max, min = _a.min, onHoverDateChange = _a.onHoverDateChange, onKeyDown = _a.onKeyDown, onSelectedDateChange = _a.onSelectedDateChange, selectedDate = _a.selectedDate, dateRange = _a.dateRange, weekStartsOn = _a.weekStartsOn;
    var weeks = eachWeekOfInterval({
        start: startOfMonth(activeDate),
        end: endOfMonth(activeDate)
    }, { weekStartsOn: weekStartsOn });
    return (React.createElement("div", { className: "tw-flex tw-flex-col tw-items-center", role: "grid", ref: ref, onKeyDown: onKeyDown, onMouseLeave: function () {
            onHoverDateChange === null || onHoverDateChange === void 0 ? void 0 : onHoverDateChange(undefined);
        } },
        React.createElement(DaysOfWeekHeader, { weekStartsOn: weekStartsOn }),
        React.createElement("div", { role: "rowgroup", className: "tw-flex tw-flex-col tw-space-y-2" }, weeks.map(function (week) { return (React.createElement(Week, { key: format(week, "w"), activeDate: activeDate, hoverDate: hoverDate, max: max, min: min, onHoverDateChange: onHoverDateChange, onSelectedDateChange: onSelectedDateChange, selectedDate: selectedDate, dateRange: dateRange, week: week, weekStartsOn: weekStartsOn })); }))));
});
DateGrid.displayName = "DateGrid";

export { DateGrid };
//# sourceMappingURL=DateGrid.esm.js.map
